import { isvalidPhone } from './regExp'


export const validPhone = (rule, value, callback) => {
  if (!value) {
    callback(new Error("请输入电话号码"));
  } else if (!isvalidPhone(value)) {
    callback(new Error("请输入正确的电话号码"));
  } else {
    callback();
  }
};